<mat-card>
    <sm-title-bar pageSubTitle="City specific data" [showBackButton]="true"></sm-title-bar>
    <div class="rounded-3 bg-light">
      <sm-data-table [columnHeaders]="tableDisplayColumn" [dataSource]="citySpecificData" [showPagination]="true" [itemsPerPage]="10"></sm-data-table>
    </div>
  </mat-card>
  
